import { useAdminAuth } from '../context/AdminAuthContext';
import AdminLoginPage from './AdminLoginPage';
import AdminDashboard from './AdminDashboard';
import '../styles/AdminGate.css';

function AdminGate() {
  const { user, isAdmin, loading, logout } = useAdminAuth();

  if (loading) {
    return <div className="admin-gate__loading">Loading…</div>;
  }

  if (!user) {
    return <AdminLoginPage />;
  }

  if (!isAdmin) {
    return (
      <div className="admin-gate__unauthorized">
        <p>Your account doesn't have admin access.</p>
        <button onClick={logout}>Sign out</button>
      </div>
    );
  }

  return <AdminDashboard />;
}

export default AdminGate;